export default __webpack_public_path__ + "static/media/hospital.2476ee2b.svg";